<template>
  <div>
    <el-form
      ref="form"
      :model="formData"
      :rules="rules"
      :disabled="disabled"
      size="medium"
    >
      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item
            :label="$l('form_label_fabric_no') || '面料编号'"
            ref="material"
            prop="fabricNo"
          >
            <el-input clearable v-model="formData.fabricNo" readonly>
              <el-button
                slot="append"
                icon="el-icon-finished"
                @click="() => (chooseFabricVisible = true)"
              ></el-button>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="16">
          <el-form-item
            :label="
              $l('form_label_Fabric_identification_name') || '面料识别名称'
            "
            prop="fabricIdentifyName"
          >
            <el-input v-model="formData.fabricIdentifyName" disabled>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$l('form_label_fabric_unit') || '面料单位'">
            <dict-select
              filterable
              v-model="formData.fabricUnit"
              url="/master/common/dict/biz"
              :body="{ dictType: 'fabricYarnUnit' }"
              disabled
              size="medium"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="$l('form_label_fabricPosition') || '面料位置'"
            prop="fabricPosition"
          >
            <dict-select
              v-model="formData.fabricPosition"
              url="/master/common/dict/biz"
              :body="{ dictType: 'fabricPosition' }"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              style="width: 100%"
              size="medium"
              filterable
              clearable
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$l('form_title_cuttingQty') || '裁剪片数'">
            <el-input-number
              controls-position="right"
              style="width: 100%"
              :min="0"
              :precision="2"
              :step="0.01"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              v-model="formData.cuttingQty"
            ></el-input-number>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :sm="{ span: 24 }" :md="{ span: 24 }" :lg="{ span: 24 }">
          <el-form-item
            :label="$l('form_label_cutting_size_Desc') || '裁剪尺寸'"
            prop="cuttingSizeDesc"
          >
            <el-input
              controls-position="right"
              style="width: 100%"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              type="textarea"
              maxlength="500"
              show-word-limit
              :rows="3"
              v-model="formData.cuttingSizeDesc"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <el-dialog
      append-to-body
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="backDialogVisible"
      width="30%"
    >
      <span>{{ $l('INDEX.tips_question_save') || '是否要保存更改' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small">{{
          $l('INDEX.product_dialog_btn_cancel') || '取消'
        }}</el-button>
        <el-button @click="close()" size="small">{{
          $l('INDEX.btn_no_save') || '不保存'
        }}</el-button>
        <el-button @click="save()" type="primary" size="small">{{
          $l('INDEX.btn_save') || '保存'
        }}</el-button>
      </span>
    </el-dialog>

    <choose-fabric-dialog
      :title="$l('dialog_title_fabric_information') || '添加面料信息'"
      :visible.sync="chooseFabricVisible"
      type="radio"
      @confirm="onFabricConfirm"
    />
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  props: {
    disabled: { type: Boolean, default: false },
    techGoodsCuttingCode: { type: String, default: '' },
    techGoodsSpecCode: { type: String, default: '' },
  },
  data() {
    return {
      formData: {
        fabricPosition: '',
        fabricIdentifyName: '',
        fabricNo: '',
        cuttingSizeDesc: '',
      },
      backDialogVisible: false,
      chooseFabricVisible: false,
      rules: {
        fabricPosition: [
          {
            required: true,
            message:
              this.$l('pe_select_label_fabricPosition') || '请选择面料位置',
            trigger: 'change',
          },
        ],
        fabricIdentifyName: [
          {
            required: true,
            message:
              this.$l('pe_input_Fabric_identification_name') ||
              '请输入面料识别名称',
            trigger: 'change',
          },
        ],
        fabricNo: [
          {
            required: true,
            message: this.$l('pe_select_label_fabric') || '请选择面料',
            trigger: 'change',
          },
        ],
        seqno: [
          {
            required: true,
            message: '请输入面料序号',
            trigger: 'change',
          },
        ],
        cuttingSizeDesc: [
          {
            required: true,
            message: this.$l('pe_input_cutting_size_Desc') || '请输入裁剪尺寸',
            trigger: 'change',
          },
        ],
      },
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      if (!this.techGoodsCuttingCode) return
      this.$api
        .techGoodsCuttingDetailApi({
          techGoodsCuttingCode: this.techGoodsCuttingCode,
        })
        .then((res) => {
          this.formData = res.body
        })
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return (this.backDialogVisible = false)
      const parms = {
        ...this.formData,
        techGoodsSpecCode: this.techGoodsSpecCode,
      }

      this.loadingOpen()
      this.$api
        .techGoodsCuttingSaveApi(parms)
        .then((res) => {
          this.loadingClose()
          const { status } = res
          if (status === 200) {
            this.$message({
              showClose: true,
              message: this.$l('INDEX.tips_save_ok') || '保存成功！',
              type: 'success',
            })
            this.$emit('close')
            this.$emit('reload')
          } else {
            this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
          }
        })
        .catch(() => {
          this.loadingClose()
        })
    },
    cancel() {
      if (this.disabled) {
        this.close()
        return
      }
      this.backDialogVisible = true
    },
    close() {
      this.backDialogVisible = false
      this.$emit('close')
    },
    onFabricConfirm(data) {
      this.formData.fabricCode = data.fabricCode
      this.formData.fabricNo = data.fabricNo
      this.formData.fabricUnit = data.fabricUnit
      this.formData.fabricWidth = data.wid
      this.formData.fabricWeight = data.fabricWeight
      this.formData.fabricIdentifyName =
        (data.fabricName || '') + ' ' + (data.fabricNameEn || '')
    },
  },
}
</script>
